/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { NumberUtils } from "abweb/utils/NumberUtils";
import * as React from "react";
export const AbProgressBar = props => {
  const {
    style,
    ...rest
  } = props;
  const progressStyle = {
    ...style,
    "--ab-progress-bar-progress-private": `${NumberUtils.clamp(props.value ?? 0, 0, 100)}%`
  };
  return /*#__PURE__*/React.createElement("div", ReactUtils.componentProps("ab-progress-bar", {
    style: progressStyle,
    ...rest
  }, [props.value === undefined && "ab-progress-bar-bounce"]));
};
//# sourceMappingURL=AbProgressBar.js.map
